import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";

const AccountDeletionPage = () => {
  const [requestOpen, setRequestOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-100 to-white">
      <Navbar />

      <main className="mx-auto max-w-3xl px-4 pb-16 pt-28 sm:px-6 sm:pt-32">
        <div className="rounded-3xl border border-sky-100 bg-white p-6 shadow-xl sm:p-10">
          <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-[#1687bd]">
            Plutonic account support
          </p>
          <h1 className="mb-4 text-3xl font-bold text-gray-900 sm:text-4xl">
            Delete your account and data
          </h1>
          <p className="mb-8 text-base leading-relaxed text-gray-700 sm:text-lg">
            Clients can request deletion of their Plutonic account and associated
            personal data by emailing our support team. You do not need to keep
            the app installed to submit a request.
          </p>

          <section className="mb-8 rounded-2xl bg-sky-50 p-5 sm:p-6">
            <h2 className="mb-3 text-xl font-semibold text-gray-900">
              How to request deletion
            </h2>
            <ol className="list-decimal space-y-3 pl-5 text-gray-700">
              <li>
                Email us from the address associated with your Plutonic account.
              </li>
              <li>
                Use the subject <strong>Plutonic account deletion request</strong>
                and include your name and Plutonic username or nickname, if known.
              </li>
              <li>
                We may ask you to verify account ownership before processing the
                request. We will confirm by email when it is complete.
              </li>
            </ol>

            <button
              type="button"
              onClick={() => setRequestOpen(true)}
              className="mt-6 inline-flex min-h-12 items-center justify-center rounded-full bg-[#22AAEE] px-6 py-3 font-semibold text-white shadow-md transition hover:bg-[#1687bd] focus:outline-none focus:ring-4 focus:ring-sky-200"
            >
              Request account deletion
            </button>
            <p className="mt-3 break-words text-sm text-gray-600">
              Or email{" "}
              <a
                className="font-semibold text-[#1687bd] underline"
                href="mailto:help@plutonic.co"
              >
                help@plutonic.co
              </a>
              .
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-gray-900">
              What will be deleted
            </h2>
            <p className="leading-relaxed text-gray-700">
              After verification, we will delete or de-identify the account and
              associated personal data that Plutonic is not required to retain.
              This may include profile information, account credentials,
              preferences, and other account-linked application data.
            </p>
          </section>

          <section className="rounded-2xl border border-amber-200 bg-amber-50 p-5 sm:p-6">
            <h2 className="mb-3 text-xl font-semibold text-gray-900">
              Information we may need to retain
            </h2>
            <p className="leading-relaxed text-gray-700">
              Some therapy, billing, security, fraud-prevention, or legal records
              may be retained for the period required by applicable law. Any
              retained information will remain protected and will not be kept
              longer than required for those purposes. Deleting a Plutonic account
              does not require your healthcare provider to delete records they are
              independently required to maintain.
            </p>
          </section>

          <p className="mt-8 text-sm text-gray-500">
            This page applies to Plutonic client accounts. Therapists and other
            organization-managed users should contact their account administrator
            or email support.
          </p>
        </div>
      </main>

      <Footer />
      <ContactModal
        isOpen={requestOpen}
        onClose={() => setRequestOpen(false)}
        defaultEmail={localStorage.getItem("userEmail") || ""}
        initialCategory="account_deletion"
      />
    </div>
  );
};

export default AccountDeletionPage;
